module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAAXNSR0IArs4c6QAAABVQTFRFAAAAMzMzMTExMzMzMjIyMzMzMzMz4v+UpQAAAAZ0Uk5TAHN3d+/7hAu/yQAAACZJREFUOMtjYBgFpAHRNCQQhCThhiyRQoyEKbJE4KjPR30+CggAAEaJQCQeG19gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/Frame@2x(2).png
// module id = GUsP
// module chunks = 1